import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { SorterResult } from 'antd/es/table/interface';
import { AppBreadcrumb, AppContainer, AppPagination } from '../atoms';
import { SpecialCalculationCostTable } from '../molecules';
import { AdminSpecialCalculationCostFilter } from '../organisms';
import { SpecialCalculationCost, SpecialCalculationCostFilterParams } from '@/types/special-calculation-cost';

interface AdminSpecialCalculationCostListTemplateProps {
  data: SpecialCalculationCost[];
  current: number;
  total: number;
  pageSize: number;
  sortInfo?: { columnKey?: string; order?: 'ascend' | 'descend' };
  onChange: (page: number) => void;
  onTableChange?: (
    sorter: SorterResult<SpecialCalculationCost> | SorterResult<SpecialCalculationCost>[]
  ) => void;
  onSearch?: (filters: SpecialCalculationCostFilterParams) => void;
  onCsvDownload?: (filters: SpecialCalculationCostFilterParams) => void;
  isCsvLoading?: boolean;
  breadcrumbItems: BreadcrumbItemType[];
  isLoading?: boolean;
}

const AdminSpecialCalculationCostListTemplate = ({
  data,
  isLoading,
  current,
  total,
  pageSize,
  sortInfo,
  onChange,
  onTableChange,
  onSearch,
  onCsvDownload,
  isCsvLoading,
  breadcrumbItems,
}: AdminSpecialCalculationCostListTemplateProps) => {
  return (
    <AppContainer>
      <main className="space-y-5 px-4">
        <AppBreadcrumb items={breadcrumbItems} />
        <h3 className="text-xl">特殊医療助成金</h3>
        <AdminSpecialCalculationCostFilter
          onSearch={onSearch}
          onCsvDownload={onCsvDownload}
          isCsvLoading={isCsvLoading}
        />
        <div className="bg-white rounded-md border">
          <SpecialCalculationCostTable
            data={data}
            isLoading={isLoading}
            sortInfo={sortInfo}
            onTableChange={onTableChange}
          />
          <div className="flex justify-end p-4">
            <AppPagination current={current} total={total} pageSize={pageSize} onChange={onChange} />
          </div>
        </div>
      </main>
    </AppContainer>
  );
};

export default AdminSpecialCalculationCostListTemplate;
